import React from 'react';
import T from 'prop-types';

const propTypes = {
  Name: T.string,
  URL: T.string,
  isLast: T.bool,
};

const Item = (item) => {
  const { Name, URL } = item;
  const lastItem = item.isLast ? (
    <span id="search-link__last-item" tabIndex="-1"></span>
  ) : null;

  return (
    <li className="search-link-item">
      <a className="search-link-item__link" href={URL}>
        <span>{Name}</span>
      </a>
      {lastItem}
    </li>
  );
};

Item.propTypes = propTypes;

export default Item;
